import React, { useRef, useState } from 'react';
import { Text, Box, Flex } from 'rebass';
import Wrapper from './Wrapper';
import DesignGiftCertificate from 'app/payment/DesignGiftCertificate';
import { patch, post } from 'utils/api';
import useLocation from 'app/hooks/location';
import { patchChildJournal } from 'child-journals/api';
// import NotReadyYetModal from './NotReadyYetModal';

const GiftCertificateDesign = ({
    hideSkip,
    onStepUp,
    onStepDown,
    email,
    setEmail,
    certificateId,
    setCertificateId,
    gift_certificate_style_id,
    setGiftCertificateStyleId,
    name_of_recipient,
    setNameOfRecipient,
    name_of_giver,
    setNameOfGiver,
    generateInvoice,
    isDisabled,
    firePostMemberEvent,
    renderheader,
    member,
}) => {
    const memberId = member?.id
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showError, setShowError] = useState(null);
    const scrollToItemRef = useRef(null)
    const { search } = useLocation();

    const onSubmit = async () => {
        try {
            if (!isDisabled) {
                setIsSubmitting(true)
                const attributes = {
                    "name-of-giver": name_of_giver,
                    "name-of-recipient": name_of_recipient,
                    "gift-certificate-style-id": gift_certificate_style_id
                }
                const queryParams = new URLSearchParams(search);
                const orderId = queryParams.get('orderId');
                const childJournalId = queryParams.get('childJournalId');

                if (orderId) attributes['shopify-order-id'] = orderId
                // Set when arriving from the Account Dashboard's "for someone else" allocation —
                // attaches this gift certificate to the journal already created for that book credit
                // instead of letting the gift flow create a second one.

                // if (childJournalId) attributes['child-journal-id'] = childJournalId

                let res = null
                if (certificateId)
                    res = await patch(`/v3/commerce/gift_certificates/${certificateId}`, {
                        data: {
                            attributes
                        }
                    })
                else
                    res = await post(`/v3/commerce/gift_certificates/`, {
                        data: {
                            attributes,
                        }
                    })

                setCertificateId(res?.data?.initial?.data?.id)

                // Arrived from the Account Dashboard's gift path: the certificate is
                // now submitted, so that journal moves unassigned → assigned. Only
                // when a childJournalId is actually present — a standalone gift
                // purchase has no journal to update.
                if (childJournalId) {
                    try {
                        await patchChildJournal({ id: childJournalId, state: 'assigned' }, {
                            gift: { gift_certificate_id: res?.data?.initial?.data?.id }
                        })
                    } catch (err) {
                        // The certificate itself succeeded; don't fail the step on this.
                        console.error('Could not mark the journal as assigned', err)
                    }
                }

                onStepUp(true)

                window.scrollBy({
                    top: 0,
                    behavior: 'smooth'
                });
                setIsSubmitting(false)
            } else {
                if (!name_of_giver)
                    setShowError({ email: 'Name of giver is required' });
                else if (!name_of_recipient)
                    setShowError({ email: 'Name of recipient is required' });

                if (scrollToItemRef.current)
                    scrollToItemRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'center',
                    });
            }
        }
        catch (err) {
            console.log(err)
        }
    }

    return (<Wrapper
        hideSkip={hideSkip}
        onSubmit={onSubmit}
        onBack={onStepDown}
        isSubmitting={isSubmitting}
        isDisabled={isDisabled}
        bg="aliceBlue"
        renderheader={renderheader}
    >
        <Box m="auto" my={["100px", "8.7%"]} mt="2.35% !important" width={['92%', '92%', '33%']} minWidth={['max-width', 480]}>
            <Text
                my="2.9%"
                color="codGrey"
                fontFamily="Bitter"
                fontSize={30}
                lineHeight="120%"
                letterSpacing="-0.18px"
                textAlign="left"
            >
                Personalize your gift certificate
            </Text>
            <Flex width="100%" sx={{
                padding: '10px',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
                gridRow: '2 / span 1',
                gridColumn: '1 / span 1',
                justifySelf: 'stretch',
                borderRadius: '10px',
                background: '#F1ECFC'
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z" fill="black" />
                    <path d="M11 11H13V17H11V11ZM11 7H13V9H11V7Z" fill="black" />
                </svg>
                <Text ml="10px" fontFamily="Poppins" fontSize={16} fontWeight={600} lineHeight="150%" letterSpacing="-0.096px" color="#0E0E0E">
                    This gift certificate will be sent to you so that you can print it or forward it to the parents.
                </Text>
            </Flex>
            {/* <NotReadyYetModal firePostMemberEvent={firePostMemberEvent} /> */}
            <DesignGiftCertificate
                ref={scrollToItemRef}
                email={email}
                setEmail={setEmail}
                setGiftCertificateStyleId={setGiftCertificateStyleId}
                gift_certificate_style_id={gift_certificate_style_id}
                name_of_recipient={name_of_recipient}
                name_of_giver={name_of_giver}
                setNameOfRecipient={setNameOfRecipient}
                setNameOfGiver={setNameOfGiver}
                generateInvoice={generateInvoice}
                setShowError={setShowError}
                showError={showError}
            />
        </Box>
    </Wrapper>
    );
};

export default GiftCertificateDesign;
